
function LocationClass( params ) {
	this.params= params;
};
$.extend( LocationClass.prototype, {
	run: function() {
		this.gmapInit(this.params);
	},
	gmapInit: function(params) {
		if( !global.hasOwnProperty('google') ) {
			window.onload= this.gmapMain(params);
			return;
		}
		this.gmapMain(params)();
	},
	gmapMain: function( params ) {

		return function() {
			_jh.each( params, function(i, v) {
				var option= {
					center: this.center,
					zoom: 17,
					gestureHandling: 'cooperative'
				}
				var target= this.target;
				var	varInt= (window.innerWidth/-500000).toFixed(3),
					markerOpt= Object.assign({}, gmapObj.markerOpt),
					markerOpt2= Object.assign({}, gmapObj.markerOpt2);
					markerOpt.position= markerOpt2.position= option.center;
				if( target ){
					var mgmap = new google.maps.Map(target, option);
					markerOpt.map= mgmap;
					markerOpt2.map= mgmap;
					new google.maps.Marker(markerOpt);
					new google.maps.Marker(markerOpt2);
				}
			});
			
		}

	}
});

export default LocationClass;